import { Insight } from "../types/insight";

const BASE = `${process.env.REACT_APP_STRAPI_APP_URL}/api`;
const READONLY_API_TOKEN = process.env.REACT_APP_Strapi_READONLY_TOKEN;

export async function fetchInsightsByInsightType(insightType: string): Promise<Insight[]> {
  const res = await fetch(
    `${BASE}/insights?filters[insightType][$eq]=${encodeURIComponent(insightType)}&populate[title][populate]=titleImage&populate[title][populate]=mainImage&sort[createdAt]=desc`,
    {
      headers: {
        Authorization: `Bearer ${READONLY_API_TOKEN}`,
      },
    }
  );
  const json = await res.json();
  return json.data;
}

export async function fetchTopInsights(): Promise<Insight[]> {
  const res = await fetch(`${BASE}/insights?populate[title][populate]=titleImage&populate[title][populate]=mainImage&pagination[limit]=2&sort[createdAt]=desc`, {
    headers: {
      Authorization: `Bearer ${READONLY_API_TOKEN}`,
    },
  });

  const json = await res.json();
  return json.data;
}

export async function fetchTopInsight(): Promise<Insight> {
  const res = await fetch(`${BASE}/insights?populate[title][populate]=titleImage&populate[title][populate]=mainImage&pagination[limit]=1&sort[createdAt]=desc`, {
    headers: {
      Authorization: `Bearer ${READONLY_API_TOKEN}`,
    },
  });

  const json = await res.json();
  return json.data[0];
}

export async function fetchAllInsights(): Promise<Insight[]> {
  const res = await fetch(`${BASE}/insights?populate[title][populate]=titleImage&populate[title][populate]=mainImage&sort[createdAt]=desc`, {
    headers: {
      Authorization: `Bearer ${READONLY_API_TOKEN}`,
    },
  });

  const json = await res.json();
  return json.data;
}

export async function fetchInsightBySlug(slug: string): Promise<Insight> {
  const res = await fetch(
    `${BASE}/insights?filters[slug][$eq]=${slug}` +
    `&populate[title][populate]=titleImage` +
    `&populate[title][populate]=mainImage` +
    `&populate[firstSection][populate]=image` +
    `&populate[secondSection][populate]=image` +
    `&populate[thirdSection][populate]=image` +
    `&populate[writer][populate]=personPicture`,
    {
      headers: {
        Authorization: `Bearer ${READONLY_API_TOKEN}`,
      },
    }
  );

  const json = await res.json();
  return json.data[0];
}
